import { ActivatedRoute, Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ViewId,
  ViewPresetApiService,
} from 'src/app/api/services/view-preset-api.service';

import { AgDataObjectCellRendererComponent } from 'src/app/ag-grid/components/cell-renderers/ag-data-object-cell-renderer/ag-data-object-cell-renderer.component';
import { AppState } from 'src/app/reducers';
import { ColDef } from 'ag-grid-community';
import { UserApiService } from 'src/app/api/services/user-api.service';
import { GeneralDynamicAgGridComponent } from 'src/app/ag-grid/components/general-dynamic-ag-grid/general-dynamic-ag-grid.component';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { LoggerService } from '@services/logger.service';
import { ObjectEditorService } from '../../services/object-editor.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dimensions',
  templateUrl:
    '../../../ag-grid/components/general-dynamic-ag-grid/general-dynamic-ag-grid.component.html',
  styleUrls: [
    '../../../ag-grid/components/general-dynamic-ag-grid/general-dynamic-ag-grid.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DimensionsComponent extends GeneralDynamicAgGridComponent {
  public viewId: ViewId = ViewId.Dimensions;

  // Rows are permission-filtered server-side - refetch when the View All
  // Company Objects toggle flips.
  protected refreshOnCompanyObjectsToggle = true;
  tableTitle = this.translateService.instant('grid.title.dimensions');
  tableIcon: IconProp = ['fas', 'layer-group'];

  protected readonly i18nViewName = 'dimensions';
  protected generalGridClassName: string = 'dimensions-grid';

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected store: Store<AppState>,
    protected route: ActivatedRoute,
    protected cdr: ChangeDetectorRef,
    protected router: Router,
    protected translateService: TranslateService,
    protected logger: LoggerService,
    protected viewPresetService: ViewPresetApiService,
    protected userApi: UserApiService,
    protected editService: ObjectEditorService,
    protected toastService: ToastService,
  ) {
    super(
      store,
      route,
      cdr,
      logger,
      router,
      viewPresetService,
      toastService,
      translateService,
    );
  }

  protected fetchAgGridData(request: any): Observable<any> {
    return this.userApi.getUserDimensionsAgGrid(request);
  }

  createColumnDefs(): ColDef[] {
    return [
      {
        headerName: this.columnHeader('name'),
        field: 'title',
        filter: 'agTextColumnFilter',
        cellRenderer: AgDataObjectCellRendererComponent,
        cellRendererParams: {
          titleKey: 'title',
          objectId: 'object_id',
          objectClassId: 'object_class_id',
          objectTypeId: 'object_type_id',
          lifecycleStatus: 'lifecycle_status',
          onClick: (data) => {
            this.editService.loadFeedAndOpenPopup(data.id);
          },
        },
        cellStyle: { overflow: 'visible' },
      },
      {
        headerName: this.columnHeader('description'),
        field: 'description',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: this.translateService.instant('grid.column.count-used'),
        field: 'count_used_as_dimension',
        sortable: false,
        floatingFilter: false,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        type: 'numericColumn',
        maxWidth: 160,
      },
      {
        headerName: this.translateService.instant('grid.column.workspace'),
        field: 'workspace.title',
        filter: 'agTextColumnFilter',
        cellRenderer: AgDataObjectCellRendererComponent,
        cellRendererParams: {
          object: 'workspace',
          titleKey: 'title',
          icon: ['fas', 'folder'],
          // Only refs the dispatcher can open are links.
          clickable: (ref) => this.editService.canOpenDataObjectRef(ref),
          onClick: (ref) => this.editService.openDataObjectRef(ref),
        },
        cellStyle: { overflow: 'visible' },
      },
      this.createOwnerColumnDef(),
      this.createAuditTrailColumnGroup({ area: 'analytics' }),
    ];
  }
}
